module.exports = __webpack_public_path__ + "static/la3.21b6759a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/gallery/la3.jpg
// module id = 539
// module chunks = 27362984104999